// src/admin/legal/legalFormStyles.js — the styles shared by the legal documents page and its two modals (v219).
// Tokens only (src/constants/theme.js), mirroring admin/pages/CreateUserModal.jsx.
import { COLORS, FONT_SANS, FONT_MONO, RADII, SEMANTIC } from '../../constants/theme.js';

export const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: RADII.controlInner,
  border: `1px solid ${COLORS.borderStrong}`, background: COLORS.surface,
  color: COLORS.ink, fontSize: '14px', boxSizing: 'border-box', outline: 'none', fontFamily: FONT_SANS,
};
export const labelStyle = {
  display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px', fontWeight: 500,
};
export const hintStyle = { fontSize: '11px', color: COLORS.textSecondary, marginTop: '4px', display: 'block' };
export const fieldErrorStyle = { fontSize: '12px', color: SEMANTIC.errore.fg, marginTop: '4px', display: 'block' };
export const fieldStyle = { marginBottom: '16px' };
export const alertStyle = {
  marginBottom: '16px', padding: '12px 16px', borderRadius: RADII.controlInner,
  background: SEMANTIC.errore.bg, color: SEMANTIC.errore.fg, fontSize: '13px',
};
export const monoStyle = { fontFamily: FONT_MONO, fontSize: '12px' };
export const buttonStyle = (primary, disabled = false) => ({
  padding: '8px 16px', borderRadius: RADII.controlInner, fontSize: '13px', fontFamily: FONT_SANS,
  cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
  ...(primary
    ? { border: 'none', background: COLORS.accent, color: COLORS.surface, fontWeight: 600 }
    : { border: `1px solid ${COLORS.borderStrong}`, background: COLORS.surface, color: COLORS.ink }),
});
export const linkButtonStyle = {
  background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: COLORS.accent,
  fontSize: '13px', fontFamily: FONT_SANS,
};
export const chipStyle = (palette) => ({
  padding: '2px 8px', borderRadius: RADII.controlInner, fontSize: '11px', fontWeight: 600,
  background: palette.bg, color: palette.fg, whiteSpace: 'nowrap',
});
